import ledgerlyImg from "../images/ledgerly.png";
import luxuryImg from "../images/luxury_store.png";
import osethraImg from "../images/osethra_hospital.png";
import unishareImg from "../images/unishare_platform.png";
import traveleaseImg from "../images/travelease.jpg";
import upcomingFintechImg from "../images/upcoming_fintech_ui.png";
import upcomingAiImg from "../images/upcoming_ai_workspace_ui.png";
import staysphereImg from "../images/staysphere.jpg";

const projectsData = [
  {
    id: 8,
    type: "Travel / Enterprise",
    title: "StaySphere — Enterprise Hotel Management & Reservation System",
    description: "A highly scalable hotel management and reservation ecosystem built with .NET 9.0 (Clean Architecture, DDD, CQRS) and React 18, featuring persistent auth, real-time SignalR push notifications, Redis caching, and Hangfire background workers.",
    techStack: [
      "React 18",
      "ASP.NET Core 9.0",
      "PostgreSQL 16",
      "Redis 7.0",
      "SignalR",
      "Hangfire",
      "Docker",
      "Tailwind CSS v3",
      "MediatR",
      "EF Core"
    ],
    image: staysphereImg,
    github: "https://github.com/RasikaPrabath/StaySphere.git",
    link: null,
    client: "Personal Showcase",
    duration: "3 Months",
    teamSize: "Individual Project",
    year: "2026",
    role: "Full-Stack Enterprise Architect",
    overview: "StaySphere is a production-ready, highly scalable, and secure hotel management and reservation ecosystem designed utilizing Enterprise Design Patterns, Domain-Driven Design (DDD) principles, and Clean Architecture. It features a dual-portal dashboard architecture for customers, hotel partners, and system administrators.",
    problem: "Hotel booking platforms require seamless coordination between room availability, dynamic pricing, persistent session authentication, instant notifications for booking confirmations, and background cleanup operations for expired unpaid bookings.",
    solution: "Built a decoupled architecture using ASP.NET Core 9.0 and React. Implemented MediatR CQRS for clean domain separation, Redis 7 for cache-aside search performance (reducing database load), SignalR for real-time WebSocket notifications, and Hangfire for automated background processing (e.g., auto-canceling unpaid reservations).",
    features: [
      "Complete Hotel Management & Booking Platform",
      "3 User Roles: Customer, Hotel Owner (Partner), Admin",
      "Hotel & Room Management",
      "Advanced Hotel Search with Redis caching",
      "Online Booking, Payments & Refunds",
      "Secure JWT Authentication with refresh tokens",
      "Real-time Notifications using SignalR",
      "Reviews, Wishlist & Coupons",
      "AI Assistant Integration",
      "Background Jobs using Hangfire",
      "Modern Tech Stack: React + .NET 9 + PostgreSQL",
      "Clean Architecture + DDD + CQRS",
      "Docker & GitHub Actions CI/CD"
    ]
  },
  {
    id: 7,
    type: "FinTech / AI",
    title: "Ledgerly — Personal Finance Tracker & AI Money Insights",
    description: "A full-stack personal finance engine featuring category budgets, automated recurring bills, hash-deduplicated bank CSV imports, client-side PDF statement exports, and plain-language monthly financial reviews generated by Google Gemini 3.5 Flash AI.",
    techStack: [
      "React 19",
      "TanStack Start",
      "TypeScript",
      "Google Gemini AI",
      "Supabase RLS",
      "Tailwind CSS v4",
      "Zod",
      "jsPDF"
    ],
    image: ledgerlyImg,
    github: "https://github.com/RasikaPrabath/fullcycle-engineer",
    link: "https://myledgerly.vercel.app/",
    client: "Personal Showcase",
    duration: "2 Months",
    teamSize: "Individual Project",
    year: "2026",
    role: "Full-Stack AI Engineer",
    overview: "Ledgerly is an intelligent personal finance tracking ecosystem and AI money insights platform. Built with React 19, TanStack Start meta-framework, Supabase RLS security, and Google Gemini 3.5 Flash AI, it provides daily transaction grouping, automated bill materialization, bank CSV hash-deduplication, interactive budget progress monitoring, and client-side PDF statement exports.",
    problem: "Managing personal finances across multiple tools often suffers from tedious manual entry, duplicate bank CSV imports, lack of actionable spending breakdown, and complex financial analysis.",
    solution: "Engineered a full-stack solution featuring 22 RPC server functions, automated recurring transaction posting with hash deduplication, Zod pre-validation, client-side PDF statement generation, and Google Gemini 3.5 Flash integration that automatically writes tailored 5-section monthly financial reviews."
  },
  {
    id: 1,
    type: "E-Commerce",
    title: "Luxury Fashion E-Commerce Platform",
    description: "LUXURY.LK is a premium e-commerce platform built with a modern dual-portal architecture. It separates a fast, conversion-focused storefront for customers from a robust administrative backend for business management.",
    techStack: [
      "Next.js 15",
      "ASP.NET Core 9.0",
      "SQL Server",
      "React 19",
      "Vanilla CSS",
      "Entity Framework Core",
      "JWT",
      "NextAuth.js"
    ],
    image: luxuryImg,
    github: "https://github.com/RasikaPrabath/Luxury-Cloths-Project",
    client: "Personal Showcase",
    duration: "2 Months",
    teamSize: "Individual Project",
    year: "2025",
    role: "Full-Stack Developer",
    overview: "LUXURY.LK is a premium e-commerce platform built with a modern dual-portal architecture. It separates a fast, conversion-focused storefront for customers from a robust administrative backend for business management.",
    problem: "Standard e-commerce frameworks often experience slow response times when loading high-resolution imagery and complex admin panels within a single monolith.",
    solution: "Created a headless architecture with Next.js 15 for lightning-fast customer interface response times and ASP.NET Core on SQL Server to securely execute backend business logic."
  },
  {
    id: 4,
    type: "Travel",
    title: "TravelEase - Tour Booking & Travel Management Platform",
    description: "A full-stack travel and tour booking platform designed to make exploring Sri Lanka easier and more enjoyable. Features destination discovery, online booking management, customer dashboard for reservations, and admin panel.",
    techStack: [
      "Next.js",
      "ASP.NET Core",
      "SQL Server",
      "C#",
      ".NET Core Clean Architecture"
    ],
    image: traveleaseImg,
    github: "https://github.com/RasikaPrabath/TravelEaseLK.git",
    client: "Personal Showcase",
    duration: "2 Months",
    teamSize: "Individual Project",
    year: "2025",
    role: "Full-Stack Developer",
    overview: "TravelEase is a full-stack tour booking and travel management platform designed to make exploring Sri Lanka easier and more enjoyable. It features destination discovery, online booking management, customer dashboards, and an admin panel.",
    problem: "Tour operators and travelers lack a unified system for live itinerary customization, tour booking, and direct coordinator communication.",
    solution: "Built a .NET Core clean architecture backend paired with a responsive Next.js frontend, providing seamless reservation tracking, live dashboards, and a robust admin panel."
  },
  {
    id: 3,
    type: "Education",
    title: "UniShare - Online Resource Sharing Platform",
    description: "A comprehensive MERN-stack web platform developed as a collaborative group project to empower university students with seamless resource sharing, interactive assessments, and virtual study sessions.",
    techStack: [
      "React.js",
      "Node.js",
      "MongoDB",
      "Express.js",
      "JWT",
      "REST APIs"
    ],
    image: unishareImg,
    github: "https://github.com/Nilan1979/Unishare-platform-ITPM-Project",
    client: "SLIIT (Academic)",
    duration: "3 Months",
    teamSize: "Group Project (4 Members)",
    year: "2024",
    role: "Lead Developer (User Management)",
    overview: "UniShare is an online resource-sharing platform built to empower university students. It facilitates peer-to-peer file sharing, resource validation, interactive quizzes, and collaborative study forums.",
    problem: "Students frequently struggle with scattered resources, unreliable document hosting, and lack of secure role-based access for academic verification.",
    solution: "Developed the complete User Management system featuring secure JWT authentication, registration, password hashing, and dynamic role-based access controls. This ensures that administrators, lecturers, and students have secure and appropriate access levels, keeping intellectual and student data fully protected."
  },
  {
    id: 2,
    type: "Healthcare",
    title: "Osethra - Full-Stack Hospital Management System",
    description: "Developed 'Osethra,' a comprehensive Full-Stack Hospital Management System designed to streamline internal hospital operations and administrative workflows. Engineered using the MERN stack and Material UI, the system features a secure, role-based architecture specifically tailored for hospital staff.",
    techStack: [
      "React.js",
      "Node.js",
      "MongoDB",
      "Express.js",
      "Material-UI (MUI)",
      "MERN Stack",
      "RESTful APIs"
    ],
    image: osethraImg,
    github: "https://github.com/Nilan1979/Osethra",
    client: "SLIIT (Academic)",
    duration: "3 Months",
    teamSize: "Group Project (4 Members)",
    year: "2024",
    role: "Lead Developer (Appointment Management)",
    overview: "Osethra is a comprehensive Full-Stack Hospital Management System designed to streamline healthcare administration. It integrates different portals for doctors, patients, and administrators to facilitate smoother workflow scheduling and clinical updates.",
    problem: "Traditional hospital workflows rely on fragmented booking methods, causing long waiting queues, overlapping doctor schedules, and delayed communication.",
    solution: "Designed and implemented the core Appointment Management module. This system automates doctor slot scheduling, registers user bookings, tracks queue status, and provides an intuitive dashboard for hospital desk staff to verify appointments, resulting in a 40% reduction in patient waiting times."
  },
  {
    id: 5,
    type: "FinTech",
    title: "PulseFin - Intelligent Wealth & Digital Banking Dashboard",
    description: "A state-of-the-art modern financial management portal featuring interactive analytics widgets, real-time balances, and decentralized transaction insight tracking.",
    techStack: [
      "Next.js 15",
      "TypeScript",
      "Tailwind CSS",
      "Node.js",
      "PostgreSQL",
      "Prisma"
    ],
    image: upcomingFintechImg,
    github: null,
    link: null,
    client: "Personal Showcase",
    duration: "2 Months",
    teamSize: "Individual Project",
    year: "2026",
    role: "Full-Stack Architect",
    overview: "PulseFin is a comprehensive digital banking and wealth analytics ecosystem. Designed with rich dark-mode aesthetics and reactive financial chart integrations, it unites fragmented financial portfolio monitoring into a clean, modern user dashboard.",
    problem: "Existing personal wealth tools often suffer from bloated legacy UX, slow data visualization libraries, and disconnected crypto and fiat data streams.",
    solution: "Developed a highly optimized TypeScript Next.js web application utilizing edge serverless functions and real-time interactive analytics widgets for intuitive financial insights."
  },
  {
    id: 6,
    type: "AI / SaaS",
    title: "CogniSphere - Generative AI Workspace & Knowledge Engine",
    description: "An intelligent productivity and collaboration platform powered by Retrieval-Augmented Generation (RAG), automated document synthesis cards, and modular task workflows.",
    techStack: [
      "React 19",
      "ASP.NET Core 9.0",
      "MongoDB Atlas",
      "Python",
      "OpenAI API",
      "Tailwind CSS"
    ],
    image: upcomingAiImg,
    github: null,
    link: null,
    client: "Personal Showcase",
    duration: "2 Months",
    teamSize: "Individual Project",
    year: "2026",
    role: "Full-Stack AI Engineer",
    overview: "CogniSphere represents a new evolution in AI-driven workspaces. By integrating MongoDB Atlas Vector Search and AI microservices with a responsive React frontend, it transforms complex technical documents into an interactive knowledge base.",
    problem: "Modern developers and researchers lose valuable hours navigating siloed documentation and performing manual notes synthesis across distributed teams and projects.",
    solution: "Implemented an enterprise-grade modular dashboard where generative AI assistants perform real-time contextual semantic search, generate automated summaries, and streamline task progress metrics."
  }
];

export default projectsData;
